import { Link } from "react-router-dom";
import { version } from "../../../package.json";
import { useBrandConfig } from "@/hooks/use-brand-config";

export function Footer() {
  const { brandConfig } = useBrandConfig();

  return (
    <footer className="border-t py-6 md:py-0">
      <div className="container flex flex-col items-center gap-4 md:h-14 md:flex-row md:justify-between">
        <div className="text-center md:text-left">
          <p className="text-sm leading-loose text-muted-foreground">
            © {brandConfig.legal.copyrightYear} {brandConfig.company.name}. All
            rights reserved.
          </p>
        </div>
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <Link to="/privacy" className="hover:underline">
            Privacy
          </Link>
          <span>•</span>
          <a href="#" data-cookie-prefs className="hover:underline">
            Cookie preferences
          </a>
          <span>•</span>
          <Link to="/terms" className="hover:underline">
            Terms
          </Link>
          <span>•</span>
          <Link to="/changelog" className="hover:underline">
            Changelog
          </Link>
          <span>•</span>
          <a
            href={brandConfig.support.helpUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {brandConfig.support.helpText}
          </a>
          <span>•</span>
          <span>v{version}</span>
        </div>
      </div>
    </footer>
  );
}
